import Tools from '@/components/tools/Tools.js'
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading, toast } from '@/shared/utils/UIHelper'
import AjuizamentoModalForm from './ajuizamentomodal-form'
import AjuizamentoRepository from '@/shared/http/repositories/crm/ajuizamento.js'
import AssuntoRepository from '@/shared/http/repositories/configurations/assunto.js'
import ObjetoAcaoRepository from '@/shared/http/repositories/configurations/objetoacao.js'
import ComarcaRepository from '@/shared/http/repositories/configurations/comarca.js'
import PrognosticoRepository from '@/shared/http/repositories/configurations/prognostico.js'
import FaseRepository from '@/shared/http/repositories/configurations/fase.js'
import { createNewFollowupWithCard } from '@/components/tools/FollowupTools'

const ModalAjuizamentoModel = {
  id: null,
  numeroProcesso: null,
  cnj: null,
  pessoaId: null,
  assuntoId: null,
  objetoAcaoId: null,
  comarcaId: null,
  prognosticoId: null,
  faseId: null,
  advogadoResponsavel: null,
  advogadoContrario: null,
  valorCausa: null,
  valorCausa2: null,
  dataDistribuicao: null,
  ultimoAndamento: null,
  cardVinculadoId: null
}

export default {
  name: 'AjuizamentoModal',
  mixins: [ActionsForm],
  data () {
    return {
      data: ModalAjuizamentoModel,
      form: AjuizamentoModalForm
    }
  },
  props: {
    card: {
      type: Object,
      default: () => ({})
    },
    person: {
      type: Object,
      default: () => ({})
    },
    ajuizamento: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    async onLoad () {
      this.onClear()
      loading.push()
      await this.loadAssunto()
      await this.loadobjetoAcao()
      await this.loadComarca()
      await this.loadPrognostico()
      await this.loadFase()
    },
    showModal () {
      this.onClear()
      this.$refs['modal-ajuizamento'].show()
      this.$nextTick(() => {
        if (!this.ajuizamento) {
          return
        }
        Tools.SetValueInForm(this.form, this.data, this.ajuizamento)
        if (this.ajuizamento.dataDistribuicao) {
          this.form.dataDistribuicao.value = new Date(this.ajuizamento.dataDistribuicao).toISOString().split('T')[0]
        }
        if (this.ajuizamento.ultimoAndamento) {
          this.form.ultimoAndamento.value = new Date(this.ajuizamento.ultimoAndamento).toISOString().split('T')[0]
        }
      })
    },
    hideModal () {
      this.onClear()
      this.$emit('Reload')
      this.$refs['modal-ajuizamento'].hide()
    },
    async loadAssunto () {
      try {
        const response = await AssuntoRepository.GetAll()
        if (response.status === 200) {
          this.form.assuntoId.options = this.onResultDropdown(response, null, f => f.nome)
        }
        loading.pop()
      } catch (error) {
        console.error(error)
        this.onException(error)
      }
    },
    async loadobjetoAcao () {
      try {
        const response = await ObjetoAcaoRepository.GetAll()
        if (response.status === 200) {
          this.form.objetoAcaoId.options = this.onResultDropdown(response, null, f => f.nome)
        }
        loading.pop()
      } catch (error) {
        console.error(error)
        this.onException(error)
      }
    },
    async loadComarca () {
      try {
        const response = await ComarcaRepository.GetAll()
        if (response.status === 200) {
          this.form.comarcaId.options = this.onResultDropdown(response, null, f => f.nome)
        }
        loading.pop()
      } catch (error) {
        console.error(error)
        this.onException(error)
      }
    },
    async loadPrognostico () {
      try {
        const response = await PrognosticoRepository.GetAll()
        if (response.status === 200) {
          this.form.prognosticoId.options = this.onResultDropdown(response, null, f => f.nome)
        }
        loading.pop()
      } catch (error) {
        console.error(error)
        this.onException(error)
      }
    },
    async loadFase () {
      try {
        const response = await FaseRepository.GetAll()
        if (response.status === 200) {
          this.form.faseId.options = this.onResultDropdown(response, null, f => f.nome)
        }
        loading.pop()
      } catch (error) {
        console.error(error)
        this.onException(error)
      }
    },
    async onUpdate () {
      if (Tools.ValidateForms(this.form, this.data, this, toast)) {
        try {
          Tools.SetValueToSave(this.form, this.data)
          this.data.pessoaId = this.person.id
          this.data.cardVinculadoId = this.card.id
          const response = await AjuizamentoRepository.Update(this.data)
          if (response.status === 200) {
            this.$emit('Reload')
            this.hideModal()
            createNewFollowupWithCard(
              this.card.pessoa.document,
              'sys_ajuizamento_editado',
              'Ajuizamento número ' + this.ajuizamento.numeroProcesso + ' Editado',
              this.ip,
              this.latitude,
              this.longitude,
              this.card.id
            )
            toast.success(this.$lang.Common.Alerts.Success)
          }
          loading.pop()
        } catch (error) {
          this.onException(error)
        }
      }
    },
    async onSave () {
      if (Tools.ValidateForms(this.form, this.data, this, toast)) {
        try {
          Tools.SetValueToSave(this.form, this.data)
          this.data.pessoaId = this.person.id
          this.data.cardVinculadoId = this.card.id
          const response = await AjuizamentoRepository.Create(this.data)
          if (response.status === 200) {
            this.$emit('Reload')
            this.hideModal()
            toast.success(this.$lang.Common.Alerts.Success)
          }
          loading.pop()
        } catch (error) {
          console.log(error)
          this.onException(error)
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/crm/details/ajuizamento/modal/ajuizamentoModal.js